module.exports = __webpack_public_path__ + "img/intro-sec01-btn.6151de51.png";